<template>
  <div>
    <div v-if="step == 'form'" v-bind:class="{ 'is-invalid': errors.contact }">
      <form class="form form--inline">
        <div class="form__text form__text--white">Не можете найти нужную специальность? Оставьте заявку и мы поможем!</div>
        <div class="form__form-group form__form-group--dark-bg">
          <input v-mask="'+7(###)###-##-##'" placeholder="+7(xxx)xxx-xx-xx" type="text" class="form-control form__form-control" v-model="contact.contact" v-bind:class="{ 'is-invalid': errors.contact }">
          <div class="invalid-feedback invalid-feedback--dark-bg" v-if="errors.contact">
            {{ errors.contact.join(', ') }}
          </div>
        </div>
        
        <button
          @click="sendForm"
          type="button"
          class="btn btn--promo-orange form__btn">Заказать звонок</button>
        <div class="form-accept">
            <div class="form-accept__text form-accept__text--white">
                Отправляя заявку, вы принимаете <a href="/legal/">условия обработки персональных данных</a>
            </div>
        </div>
      </form>
    </div>
    <div v-if="step == 'complete'">
      <p class="text-success">
        Ваше сообщение успешно отправлено! Мы свяжемся с Вами в ближайшее время.
      </p>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueMask from 'v-mask'

import FormMixin from '../vue_mixins/FormMixin.vue'

Vue.use(VueMask)


export default {
  name: 'CallmeFormHorizontally',
  mixins: [FormMixin],
  data() {
    return {
      contact: {},
      errors: {},
      step: 'form'
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    sendForm: function () {
      axios.put("/contacts/api/callme/", this.contact)
      .then(response => {
        this.contact = response.data;
        this.step = 'complete';
        ym(97921240,'reachGoal','CALLME_MESSAGE');
        setTimeout(() => {
          this.initData()
        }, 3500)
      })
      .catch(error => {
        this.errors = error.response.data;
        setTimeout(() => {
          this.initData()
        }, 5000)
      });
    },

    initData () {
      axios.get("/contacts/api/callme/").then(response => {this.contact = response.data})
      this.errors = {}
      this.step = 'form'
    }
  }
}
</script>

<style lang="scss">
</style>
